
// Vue
import {Options, Vue} from "vue-class-component";

@Options({})
export default class CoachTrainingsNavigationVue extends Vue {}
